import React from 'react';
import { useParams } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';
import { useTranslation } from "react-i18next";

import { getApiBaseUrl, getLang, getProvince } from '../../../utils';

import { handleRequest } from '../../../stories/helpers/httpRequest';
import { SummaryConstants as Constants } from '../../../Helpers/summaryconstants';

import { SpecsItem } from '../../2_Molecules/SpecsItem/SpecsItem';

export const BuildSpecs = ({ componentRef, ...props }) => {
    const { t, i18n } = useTranslation(['summary', 'packages', 'general', 'payments']);
    const { year, carline, trim, model, packageCode } = useParams();

    const defaultEngineUrl = `${getApiBaseUrl()}/api/EngineModels/${year}/${carline}/${trim}/?prov_code=${getProvince()}&lang_code=${getLang()}`;
    const defaultPackageUrl = `${getApiBaseUrl()}/api/Packages/${model}/${packageCode}/?prov_code=${getProvince()}&lang_code=${getLang()}`;


    const [defaultDrivetrain, setDefaultDrivetrain] = React.useState(null);
    const [defaultEngine, setDefaultEngine] = React.useState(null);
    const [defaultPackages, setDefaultPackage] = React.useState(null);


    let { selectedTrim, selectedTrimUrl} = '';
    let { selectedModel, selectedModelUrl} = '';
    let { selectedPackage, selectedPackageUrl} = '';
    let { selectedColoursInt, selectedColoursExt, selectedColoursUrl} = '';
    let { selectedWheel, selectedWheelUrl} = '';
    let { selectedConnectivity, selectedConnectivityUrl} = '';
    let { selectedAddedProtection, selectedAddedProtectionUrl} = '';
    let { selectedAppearanceProtectionPlan, selectedAppearanceProtection, selectedAppearanceProtectionUrl} = '';

    let isWide = false;

    async function defaultEngineRequest() {
        handleRequest('get', defaultEngineUrl, {}).then(requestResponse => {
            const data = requestResponse.data;
            const defaultDrivetrain = data.models[0].drivetrain.label;
            const defaultEngine = data.models[0].engine.label;
            setDefaultDrivetrain(defaultDrivetrain);
            setDefaultEngine(defaultEngine);
        }).catch(error => {
            console.log(error);
        });
    }

    async function defaultPackagesRequest() {
        handleRequest('get', defaultPackageUrl, {}).then(requestResponse => {
            const data = requestResponse.data;
            setDefaultPackage(data);
        }).catch(error => {
            console.log(error);
        });
    }

    if (!defaultEngine) {
        defaultEngineRequest();
    }

    if (!defaultPackages) {
        defaultPackagesRequest();
    }

    if (defaultEngine) {
        let model = { engine: { label: defaultEngine }, drivetrain: { label: defaultDrivetrain } };
        selectedModel = model;
        let modelUrl = '/' + year + '/' + carline + '/' + trim;
        selectedModelUrl = modelUrl

    }

    if (defaultPackages) {
        let packages = { name: defaultPackages.packages[0] ?.name};
        selectedPackage = packages;
        let packageUrl = '/' + year + '/' + carline + '/' + trim + '/' + model + '/' + packageCode + '/#';
        selectedPackageUrl = packageUrl
    }

    if (sessionStorage.getItem('selectedTrim')) {
        selectedTrim = sessionStorage.getItem('selectedTrim');
        selectedTrim = JSON.parse(selectedTrim);

        selectedTrimUrl = sessionStorage.getItem('urlSlugObjectTrims');
        selectedTrimUrl = JSON.parse(selectedTrimUrl);
        selectedTrimUrl = '/' + selectedTrimUrl.year + '/' + selectedTrimUrl.carline;
    }

    if (sessionStorage.getItem('selectedModel')) {
        selectedModel = sessionStorage.getItem('selectedModel');
        selectedModel = JSON.parse(selectedModel);

        selectedModelUrl = sessionStorage.getItem('urlSlugObjectEngineAndDrivetrain');
        selectedModelUrl = JSON.parse(selectedModelUrl);
        selectedModelUrl = '/' + selectedModelUrl.year + '/' + selectedModelUrl.carline + '/' + selectedModelUrl.trim;
    }

    if (sessionStorage.getItem('selectedPackage')) {
        selectedPackage = sessionStorage.getItem('selectedPackage');
        selectedPackage = JSON.parse(selectedPackage);

        // Added this in the case of the build id passed in the url
        if (sessionStorage.getItem('urlSlugObjectPackage')) {
            selectedPackageUrl = sessionStorage.getItem('urlSlugObjectPackage');
            selectedPackageUrl = JSON.parse(selectedPackageUrl);
            selectedPackageUrl = '/' + selectedPackageUrl.year + '/' + selectedPackageUrl.carline + '/' + selectedPackageUrl.trim + '/' + selectedPackageUrl.model + '/' + (selectedPackageUrl.option ? selectedPackageUrl.option : selectedPackageUrl.packageCode);
        } else {
            selectedPackageUrl = defaultPackageUrl;
        }
    }

    if (sessionStorage.getItem('selectedInteriorColour')) {
        selectedColoursInt = sessionStorage.getItem('selectedInteriorColour');
        selectedColoursExt = sessionStorage.getItem('selectedExteriorColour');
        selectedColoursInt = JSON.parse(selectedColoursInt);
        selectedColoursExt = JSON.parse(selectedColoursExt);

        selectedColoursUrl = sessionStorage.getItem('urlSlugObjectColour');
        selectedColoursUrl = JSON.parse(selectedColoursUrl);
        selectedColoursUrl = '/' + selectedColoursUrl.year + '/' + selectedColoursUrl.carline + '/' + selectedColoursUrl.trim + '/' + selectedColoursUrl.model + '/' + selectedColoursUrl.packageCode + '/colours/';
    } else if (sessionStorage.getItem('defaultExteriorColour')) {
        selectedColoursInt = sessionStorage.getItem('defaultInteriorColour');
        selectedColoursExt = sessionStorage.getItem('defaultExteriorColour');
        selectedColoursInt = JSON.parse(selectedColoursInt);
        selectedColoursExt = JSON.parse(selectedColoursExt);

        selectedColoursUrl = '/' + year + '/' + carline + '/' + trim + '/' + model + '/' + packageCode + '/colours/';
    } else {
        selectedColoursUrl = '/' + year + '/' + carline + '/' + trim + '/' + model + '/' + packageCode + '/colours/';
    }

    if (sessionStorage.getItem('selectedWheel')) {
        selectedWheel = sessionStorage.getItem('selectedWheel');
        selectedWheel = JSON.parse(selectedWheel);

        selectedWheelUrl = sessionStorage.getItem('urlSlugObjectWheels');
        selectedWheelUrl = JSON.parse(selectedWheelUrl);
        selectedWheelUrl = '/' + selectedWheelUrl.year + '/' + selectedWheelUrl.carline + '/' + selectedWheelUrl.trim + '/' + selectedWheelUrl.model + '/' + selectedWheelUrl.packageCode + '/wheels';
    } else {
        selectedWheelUrl = '/' + year + '/' + carline + '/' + trim + '/' + model + '/' + packageCode + '/wheels';
    }

    if(sessionStorage.getItem('selectedConnectedVehiclePackage')) {
        selectedConnectivity = sessionStorage.getItem('selectedConnectedVehiclePackage');
        selectedConnectivity = JSON.parse(selectedConnectivity);
    }
    selectedConnectivityUrl = '/'+year+'/'+carline+'/'+trim+'/'+model+'/'+packageCode+'/connectivity';


    if(sessionStorage.getItem('selectedAppearanceProtectionPlansPackage')) {
        // TODO : TRANSFORM INTO A FUNCTION SUMMARYCALCULATOR
        if(window.summaryCalculator.Packages?.appearance_protection){
            Object.entries(window.summaryCalculator.Packages.appearance_protection[0].plans).map(([key, value], planIndex) => {
                if(planIndex === Number(window.summaryCalculator.SelectedAppearanceProtectionIndex)) {
                    selectedAppearanceProtectionPlan = value;
                }
            });
        }

        selectedAppearanceProtection = sessionStorage.getItem('selectedAppearanceProtectionPlansPackage');
        selectedAppearanceProtection = JSON.parse(selectedAppearanceProtection);
    }
    selectedAppearanceProtectionUrl = '/'+year+'/'+carline+'/'+trim+'/'+model+'/'+packageCode+'/protections#ap';

    if(sessionStorage.getItem('selectedAddedProtectionPackage')) {
        selectedAddedProtection = sessionStorage.getItem('selectedAddedProtectionPackage');
        selectedAddedProtection = JSON.parse(selectedAddedProtection);
    }
    selectedAddedProtectionUrl = '/'+year+'/'+carline+'/'+trim+'/'+model+'/'+packageCode+'/protections#map';

    function getProtectionDetails() {
        let list = "<p>";

        if(window.summaryCalculator.SelectedAddedProtectionPackage.name != undefined ){
            list += `${t('payments:added_protection')} ${window.summaryCalculator.SelectedAddedProtectionPackage.name}`
        }
        if(window.summaryCalculator.SelectedAppearanceProtectionPlan.name != undefined && window.summaryCalculator.SelectedAppearanceProtectionPlansIndex !== null) {
            if(window.summaryCalculator.SelectedAddedProtectionPackage.name != undefined ){
                list += ', '
            }
            list += `<p class="desc">${t('payments:appearance_protection')} <span style="text-transform:lowercase">${window.summaryCalculator.SelectedAppearanceProtectionPlansPackage.name} for ${window.summaryCalculator.SelectedAppearanceProtectionPlan.name}</span></p>`
        }           
        list += "</p>"
        return list;
    }

    function getPackageName() {
        let packageName = '';


        const selectedPackageIndex = JSON.parse(sessionStorage.getItem(Constants.SelectedPackageIndex));
        if (selectedPackageIndex !== null)
            packageName += `<span>${selectedPackage.name}</span>`;

        const selectedWarrantyPackage = JSON.parse(sessionStorage.getItem('selectedWarrantyPackage'));
        if (selectedWarrantyPackage != null && selectedWarrantyPackage.name != undefined) {
            isWide = true;
            if (packageName != '') packageName += ', <br>';
            packageName += `<span>${t("packages:warranties")}</span>&nbsp;: <span>${selectedWarrantyPackage.name}</span>`;
        }
        const selectedConnectedVehiclePackage = JSON.parse(sessionStorage.getItem('selectedConnectedVehiclePackage'));
        if (selectedConnectedVehiclePackage != null && selectedConnectedVehiclePackage.name != undefined) {
            isWide = true;
            if (packageName != '') packageName += ', <br>';
            packageName += `<span>${t("packages:connected")}</span>&nbsp;: <span>${selectedConnectedVehiclePackage.name}</span>`;
        }
        if (packageName === '')
            t("general:none_selected");

        return packageName;
    }

    React.useEffect(() => {
    }, []);

    return (
        <div className="mz-summary--specs" ref={componentRef}>
            <h3>{t("your_build_specifications")}</h3>
            <SpecsItem SpecsItemName={t("trim")} SpecsItemModel={selectedTrim? selectedTrim.trim_type.name : '' } SpecsItemEditUrl={selectedTrimUrl? selectedTrimUrl : '/#/'} />
            <SpecsItem SpecsItemName={t("options")} SpecsItemModel={selectedModel ? selectedModel.engine.label +' '+ selectedModel.drivetrain.label : '' } SpecsItemEditUrl={selectedModelUrl ? selectedModelUrl : '/#/'} />
            <SpecsItem SpecsItemName={t("package")} SpecsItemModel={ getPackageName() } SpecsItemEditUrl={selectedPackageUrl} useHTML={isWide}  isPackage={true} />
            <SpecsItem SpecsItemName={t("exterior")} SpecsItemModel={selectedColoursExt? selectedColoursExt.description : ''} SpecsItemEditUrl={selectedColoursUrl} />
            <SpecsItem SpecsItemName={t("interior")} SpecsItemModel={selectedColoursInt? selectedColoursInt.description : ''} SpecsItemEditUrl={selectedColoursUrl} />
            <SpecsItem SpecsItemName={t("wheels")} SpecsItemModel={selectedWheel? selectedWheel.title : t("wheels_default")} SpecsItemEditUrl={selectedWheelUrl} />
            {/* <SpecsItem SpecsItemName={t("protection")} SpecsItemModel={getProtectionDetails()} SpecsItemEditUrl={selectedAppearanceProtectionUrl} />             */}
        </div>
    )
};

BuildSpecs.defaultProps = {
    componentRef: null,
}